import styled from 'styled-components';

import { Skeleton } from '@gympass/yoga';

import { ContainerMessageBalloonProps } from './types';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ContainerMessageBalloon = styled.div<ContainerMessageBalloonProps>`
  display: flex;
  margin: ${({ theme }) => theme.yoga.spacing.xxxsmall}px
    ${({ theme }) => theme.yoga.spacing.xxxsmall}px
    ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.xxxsmall}px;

  width: 100%;
  justify-content: ${props => props.alignMessage};
`;

export const MessageBalloon = styled(Skeleton).attrs({
  width: 249,
  height: 203,
  type: 'rectangular',
})`
  margin: ${({ theme }) => theme.yoga.spacing.xxxsmall}px
    ${({ theme }) => theme.yoga.spacing.huge}px;
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  background-color: ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
`;
